module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/core-js/object/define-properties.js
// module id = 56
// module chunks = 0 2 6 7 10 11 13 14 17 19 21 22 25 41 43 44 45 47 48 49 51